import React from "react"
import {Badge} from "react-bootstrap"
import {MatrixAxis} from "../../../state/product/matrix/Matrix"

type Props = {
    axis: MatrixAxis
}

const MatrixAxisOptionRowComponent = (props: Props) => {
    return (
        <div>
            {props.axis.name}
            <div>
                {props.axis.options.map((o, i) => {
                    return <Badge key={i} className={"mr-1"} variant="secondary">{o.attributes.name}</Badge>
                })}
            </div>
        </div>
    )
}
export default MatrixAxisOptionRowComponent


// WEBPACK FOOTER //
// ./src/product/variant/component/MatrixAxisOptionRowComponent.tsx